import 'cirrus-ui'
import {
    Link, useMatch,
    useResolvedPath
} from 'react-router-dom'

export function NavigationItem(props) {

    let resolved = useResolvedPath(props.url);
    let match = useMatch({ path: resolved.pathname, end: true });

    return (
        <div className={match ? 'nav-item active' : 'nav-item'}>
            <Link to={props.url}>{props.text}</Link>
        </div>
    )
}

